export default "/assets/56bdf84751634e8deaff10d1d68df316.woff";